const Semester = {

    // FIELDS
    "semester_name": "Semester Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "semester": "Semester",

    // ERROR
    "error_name": "Enter Semester Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": "SEMESTER NAME",
    "table_status": "STATUS",

}

export default Semester;
